import { render, staticRenderFns } from "./example.vue?vue&type=template&id=b6487e08&scoped=true&"
import script from "./example.js?vue&type=script&lang=js&"
export * from "./example.js?vue&type=script&lang=js&"
import style0 from "./example.vue?vue&type=style&index=0&id=b6487e08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6487e08",
  null
  
)

export default component.exports